import React, { useState } from 'react';
import { useEffect } from 'react';
import { Grid, makeStyles, CircularProgress, Typography, Button, LinearProgress } from '@material-ui/core';
import { Container } from 'reactstrap';
import * as azblob from '@azure/storage-blob';
import InterimUpload from './InterimUpload';

const useStyles = makeStyles((theme) => ({
    root: {
        '& > *': {
            margin: theme.spacing(1),
        },
    },
    input: {
        display: 'none',
    },
}));


const UploadBlobAzure = (props) => {
    const classes = useStyles();
    const [inskrywing, setInskrywingInfo] = useState();
    const [fileInfo, setFileInfo] = useState();
    const [referInfo, setReferInfo] = useState({
        "bt_id": "",
        "st_id": "",
        "ordernumber": "",
        "projek": "",

    });
    const [inskrywingId, setInskrywingId] = useState(0);
    const [progressVal, setProgressVal] = useState(0);

    const [status, reportStatus] = useState('Oplaai het begin...');
    const [isUploading, setIsUploading] = useState(false);
    const [vid, setVid] = useState("GEEN");
    const [kuns, setKuns] = useState("GEEN");
    const [teks, setTeks] = useState("GEEN");
    const [skryfTeks, setSkryfTeks] = useState("GEEN");

    const [vidOpgelaai, setVidOpgelaai] = useState(false);
    const [kunsOpgelaai, setKunsOpgelaai] = useState(false);
    {/* No longer submitting text for DigiKuns, set teksOpgelaai as always TRUE */ }
    const [teksOpgelaai, setTeksOpgelaai] = useState(true);
    const [skryfTeksOpgelaai, setSkryfTeksOpgelaai] = useState(false);
    //containername will change depending on referrer path
    //containername split into state instead of hardcoding
    const [containerName, setContainerName] = useState("");
    const [isDigiKuns, setIsDigiKuns] = useState(false);

    const accountName = "projektestorage";
    const sasString = process.env.REACT_APP_STORAGE_ACCOUNT_ACCESS_KEY;
    //const containerName = "digipraat2021";
    const containerURL = new azblob.ContainerURL(
        `https://${accountName}.blob.core.windows.net/${containerName}?${sasString}`,
        azblob.StorageURL.newPipeline(new azblob.AnonymousCredential));

    const fileInput = document.getElementById("vid-input");
    const kunsInput = document.getElementById("kuns-input");
    const teksInput = document.getElementById("teks-input");
    const skryfTeksInput = document.getElementById("skryfteks-input");
    //use document referrer to control user's upload 'flow'
    //first check that user was linked by https://lede.atkv.org.za, else redirect to intupload
    //then grab info from referrer path based on project in path
    useEffect(() => {
        var docRef = document.referrer;
        console.log(docRef);
        console.log(window.location);
        if (docRef.includes("https://lede.atkv.org.za")) {
            //path so far: /Project/indivgroep/ordernumber/0/BT_ID/ST_ID
            //can declare path as safe to index, no other links to current site from lede.atkv.org.za
            //get project by projPath index [2]
            //setOrderNumber
            var ordernumber = window.location.pathname.split('/')[4];
            //setOrdinalForGroups, pass in 'groep' or 'indv' in url
            if (window.location.pathname.includes("groep")) {
                var ordinal = window.location.pathname.split('/')[5];
            }
            var bt_id = window.location.pathname.split('/')[6];
            var st_id = window.location.pathname.split('/')[7];
            var projPath = window.location.pathname.split('/')[2];
            setReferInfo({
                "bt_id": bt_id,
                "st_id": st_id,
                "ordernumber": ordernumber,
                "projek": projPath,
                "ordinal": ordinal
            }
            )
            //when setting containerName, add year
            setContainerName(projPath.toLowerCase() + "2023");
            //if projPath is DigiKuns, show/hide DigiKuns input fields
            //moved switch to return statement (does exactly the same, but now checking in render)
            //switch (projPath) {
            //    case "DigiKuns":
            //        setIsDigiKuns(true);
            //        break;
            //}
        }
        else {
            window.alert("Klik asseblief op die skakel op https://lede.atkv.org.za om jou inskrywing op te laai.");
            window.location.replace("https://digiinskryf.atkv.org.za/intupload");
        }

    }, [])


    const uploadVidToBlob = async () => {
        //await finishSubmit();
        //
        reportStatus("Besig om op te laai, gee asseblief 1-2 minute tyd...");
        const promises = [];
        for (const file of fileInput.files) {
            const blockBlobURL = azblob.BlockBlobURL.fromContainerURL(containerURL, referInfo.bt_id + "-" + referInfo.st_id + "-order-" + referInfo.ordernumber + "-inskrywing-" + inskrywingId + '.' + fileInput.files[0].name.split('.').pop());
            promises.push(azblob.uploadBrowserDataToBlockBlob(
                azblob.Aborter.none, file, blockBlobURL, {
                progress: ev => setProgressVal((ev.loadedBytes / file.size) * 100)

            }));
        }

        var x = await Promise.all(promises);
        console.log("LOGGING AWAITED PROMISES");
        console.log(x);
        console.log(x[0]._response.status);
        if (x[0]._response.status === 201) {
            reportStatus("Sukses!");
            setIsUploading(false);
            await fetch('api/User/opdateerinskrywing/digipraat/' + inskrywingId, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json"

                },
                body: JSON.stringify({
                    "originalFileName": fileInput.files[0].name,
                    "fileName": referInfo.bt_id + "-" + referInfo.st_id + "-order-" + referInfo.ordernumber + "-inskrywing-" + inskrywingId + '.' + fileInput.files[0].name.split('.').pop(),
                    "size": String(fileInput.files[0].size),
                    "extension": String(fileInput.files[0].name.split('.').pop())
                })
            }).catch(() => {
                window.alert("OEPS! Iets het fout gegaan terwyl jou inskrywing opgelaai was... Probeer asseblief weer jou inskrywing oplaai.");
                window.setTimeout(window.location.replace("https://lede.atkv.org.za"), 500);
            })

            window.setTimeout(window.location.replace("https://digiinskryf.atkv.org.za/suksesinskryf"), 500);

        }
        else {
            window.alert("OEPS! Iets het fout gegaan terwyl jou inskrywing opgelaai was... Probeer asseblief weer jou inskrywing oplaai.");
            window.setTimeout(window.location.replace("https://lede.atkv.org.za"), 500);

        }
    }

    const uploadKunsToBlob = async () => {
        reportStatus("Besig om op te laai, gee asseblief 1-2 minute tyd...");
        const promises = [];
        // no longer submitting teksInput files for 2022 DigiKuns
        //for (const file of teksInput.files) {

        //    const blockBlobURL = azblob.BlockBlobURL.fromContainerURL(containerURL, referInfo.bt_id + "-" + referInfo.st_id + "-order-" + referInfo.ordernumber + "-inskrywing-teks-" + inskrywingId + '.' + teksInput.files[0].name.split('.').pop());
        //    promises.push(azblob.uploadBrowserDataToBlockBlob(
        //        azblob.Aborter.none, file, blockBlobURL, {
        //        progress: ev => setProgressVal((ev.loadedBytes / (teksInput.files[0].size + kunsInput.files[0].size)) * 100)

        //    }));
        //}
        for (const file of kunsInput.files) {
            const blockBlobURL = azblob.BlockBlobURL.fromContainerURL(containerURL, referInfo.bt_id + "-" + referInfo.st_id + "-order-" + referInfo.ordernumber + "-inskrywing-kuns-" + inskrywingId + '.' + kunsInput.files[0].name.split('.').pop());
            promises.push(azblob.uploadBrowserDataToBlockBlob(
                azblob.Aborter.none, file, blockBlobURL, {
                progress: ev => setProgressVal((ev.loadedBytes / (teksInput.files[0].size + kunsInput.files[0].size)) * 100)

            }));
        }
        var x = await Promise.all(promises);
        console.log("LOGGING AWAITED PROMISES");
        console.log(x);
        console.log(x[0]._response.status);
        if (x[0]._response.status === 201) {
            reportStatus("Sukses!");
            setIsUploading(false);
            //controller for updating record can stay on path digipraat
            await fetch('api/User/opdateerinskrywing/digipraat/' + inskrywingId, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json"

                },
                // filename and other info needs to be edited. No longer submitting 2 files. 
                body: JSON.stringify({
                    "originalFileName": kunsInput.files[0].name,
                    "fileName": referInfo.bt_id + "-" + referInfo.st_id + "-order-" + referInfo.ordernumber + "-inskrywing-kuns-" + inskrywingId,
                    "size": String(kunsInput.files[0].size),
                    "extension": String(String(kunsInput.files[0].name.split('.').pop()))
                })
            }).catch(() => {
                window.alert("OEPS! Iets het fout gegaan terwyl jou inskrywing opgelaai was... Probeer asseblief weer jou inskrywing oplaai.");
                window.setTimeout(window.location.replace("https://lede.atkv.org.za"), 500);
            })

            window.setTimeout(window.location.replace("https://digiinskryf.atkv.org.za/suksesinskryf"), 500);

        }
        else {
            window.alert("OEPS! Iets het fout gegaan terwyl jou inskrywing opgelaai was... Probeer asseblief weer jou inskrywing oplaai.");
            window.setTimeout(window.location.replace("https://lede.atkv.org.za"), 500);

        }

    }

    const uploadSkryfToBlob = async () => {
        reportStatus("Besig om op te laai, gee asseblief 1-2 minute tyd...");
        const promises = [];
        for (const file of skryfTeksInput.files) {

            const blockBlobURL = azblob.BlockBlobURL.fromContainerURL(containerURL, referInfo.bt_id + "-" + referInfo.st_id + "-order-" + referInfo.ordernumber + "-inskrywing-teks-" + inskrywingId + '.' + skryfTeksInput.files[0].name.split('.').pop());
            promises.push(azblob.uploadBrowserDataToBlockBlob(
                azblob.Aborter.none, file, blockBlobURL, {
                progress: ev => setProgressVal((ev.loadedBytes / (teksInput.files[0].size + kunsInput.files[0].size)) * 100)

            }));
        }
        var x = await Promise.all(promises);
        console.log("LOGGING AWAITED PROMISES");
        console.log(x);
        console.log(x[0]._response.status);
        if (x[0]._response.status === 201) {
            reportStatus("Sukses!");
            setIsUploading(false);
            //controller for updating record can stay on path digipraat
            await fetch('api/User/opdateerinskrywing/digipraat/' + inskrywingId, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json"

                },
                body: JSON.stringify({
                    "originalFileName": skryfTeksInput.files[0].name,
                    "fileName": referInfo.bt_id + "-" + referInfo.st_id + "-order-" + referInfo.ordernumber + "-inskrywing-teks-" + inskrywingId,
                    "size": String(skryfTeksInput.files[0].size),
                    "extension": String(skryfTeksInput.files[0].name.split('.').pop())
                })
            }).catch(() => {
                window.alert("OEPS! Iets het fout gegaan terwyl jou inskrywing opgelaai was... Probeer asseblief weer jou inskrywing oplaai.");
                window.setTimeout(window.location.replace("https://lede.atkv.org.za"), 500);
            })

            window.setTimeout(window.location.replace("https://digiinskryf.atkv.org.za/suksesinskryf"), 500);

        }
        else {
            window.alert("OEPS! Iets het fout gegaan terwyl jou inskrywing opgelaai was... Probeer asseblief weer jou inskrywing oplaai.");
            window.setTimeout(window.location.replace("https://lede.atkv.org.za"), 500);

        }

    }

    const vidInputChanged = (e) => {
        //has file in fileInput?
        if (e.target.files.length > 0) {
            //check if extension is valid
            //get extension for file
            var x = e.target.files[0].name.split('.').pop()
            if (String(x).includes("mp4") || String(x).includes("mov") || String(x).includes("MOV") || String(x).includes("MP4")) {
                setVid("Videomateriaal gekies!");
                setVidOpgelaai(true);
                setInskrywingInfo({ ...inskrywing, "vidGelaai": true });
                setInskrywingInfo({ ...inskrywing, "originalFileName": e.target.files[0].name, })

            }
            else {
                //invalid extension
                window.alert("Geen inskrywing opgelaai nie. Maak asseblief seker u kies 'n *.mp4 of *.MOV lêer om op te laai.");
                setVid("");
                setVidOpgelaai(false);
                setInskrywingInfo({ ...inskrywing, "vidGelaai": false });

            }
            console.log(x);
        }
        else {
            setVid("");
            setVidOpgelaai(false);
            setInskrywingInfo({ ...inskrywing, "vidGelaai": false });

        }

        //cannot upload multiple files
        if (e.target.files.length > 1) {
            setVid("Kies asseblief 1 leêr om op te laai en probeer weer.");
            setVidOpgelaai(false);
            setInskrywingInfo({ ...inskrywing, "vidGelaai": false });
        }
        //  console.log(e.target.files);
        //  console.log(e.target.files.length);

    }

    const kunsInputChanged = (e) => {
        if (e.target.files.length > 0) {
            setKuns("Kuns gekies!");
            setKunsOpgelaai(true);
            setInskrywingInfo({ ...inskrywing, "kunsGelaai": true });
            //get extension for file
            var x = e.target.files[0].name.split('.').pop()
            setInskrywingInfo({ ...inskrywing, "originalFileNameKuns": e.target.files[0].name, })
            console.log(x);

        }
        else {
            setKuns("");
            setKunsOpgelaai(false);
            setInskrywingInfo({ ...inskrywing, "kunsGelaai": false });

        }

        //cannot upload multiple files
        if (e.target.files.length > 1) {
            setKuns("Kies asseblief 1 leêr om op te laai en probeer weer.");
            setKunsOpgelaai(false);
            setInskrywingInfo({ ...inskrywing, "kunsGelaai": false });
        }
        // console.log(e.target.files);
        // console.log(e.target.files.length);

    }

    const teksInputChanged = (e) => {
        if (e.target.files.length > 0) {
            setTeks("Teks gekies!");
            setTeksOpgelaai(true);
            setInskrywingInfo({ ...inskrywing, "teksGelaai": true });
            //get extension for file
            var x = e.target.files[0].name.split('.').pop()
            setInskrywingInfo({ ...inskrywing, "originalFileNameTeks": e.target.files[0].name, })
            console.log(x);

        }
        else {
            setTeks("");
            setTeksOpgelaai(false);
            setInskrywingInfo({ ...inskrywing, "teksGelaai": false });

        }

        //cannot upload multiple files
        if (e.target.files.length > 1) {
            setTeks("Kies asseblief 1 leêr om op te laai en probeer weer.");
            setTeksOpgelaai(false);
            setInskrywingInfo({ ...inskrywing, "teksGelaai": false });
        }
        //console.log(e.target.files);
        //console.log(e.target.files.length);

    }

    const skryfTeksInputChanged = (e) => {
        //has file in fileInput?
        if (e.target.files.length > 0) {
            //check if extension is valid
            //get extension for file
            var x = e.target.files[0].name.split('.').pop()
            var checkString = String(x).toLowerCase();
            if (checkString.includes("doc") || checkString.includes("docx") || checkString.includes("pdf") || checkString.includes("txt") || checkString.includes("jpeg") || checkString.includes("jpg")) {
                setSkryfTeks("Teks gekies!");
                setSkryfTeksOpgelaai(true);
                setInskrywingInfo({ ...inskrywing, "skryfTeksOpgelaai": true });
                setInskrywingInfo({ ...inskrywing, "originalFileName": e.target.files[0].name, })

            }
            else {
                //invalid extension
                window.alert("Geen inskrywing opgelaai nie. Maak asseblief seker u kies 'n *.mp4 of *.MOV lêer om op te laai.");
                setSkryfTeks("");
                setSkryfTeksOpgelaai(false);
                setInskrywingInfo({ ...inskrywing, "skryfTeksOpgelaai": false });

            }
            console.log(x);
        }
        else {
            setSkryfTeks("");
            setSkryfTeksOpgelaai(false);
            setInskrywingInfo({ ...inskrywing, "skryfTeksOpgelaai": false });

        }

        //cannot upload multiple files
        if (e.target.files.length > 1) {
            setSkryfTeks("Kies asseblief 1 leêr om op te laai en probeer weer.");
            setSkryfTeksOpgelaai(false);
            setInskrywingInfo({ ...inskrywing, "skryfTeksOpgelaai": false });
        }
        //  console.log(e.target.files);
        //  console.log(e.target.files.length);

    }

    useEffect(() => {
        console.log(inskrywingId);
        if (inskrywingId !== 0) {
            //only videos can use uploadVidToBlob

            if (referInfo.projek === "DigiKuns") {
                uploadKunsToBlob();
            }
            else if (referInfo.projek === "DigiPraat") {       
                uploadVidToBlob();
            }
            else if (referInfo.projek === "Redenaars") {
                uploadVidToBlob();
            }
            else if (referInfo.projek === "DigiSpanpraat") {
                uploadVidToBlob();
            }

            else if (referInfo.projek === "DigiSkryf") {
                uploadSkryfToBlob();
            }

        }

    }, [inskrywingId])

    const finishRegistration = async () => {
        //when finished uploading is clicked, create db entry for newUploadedFiles and set oplaaistatus as 'Besig om op te laai'
        //add if statement for groups (add ordinal in fetch query)
        //start upload ui
        setVidOpgelaai(false);
        setIsUploading(true);
        if (window.location.pathname.includes("groep")) {
            fetch('api/User/nuweinskrywing/' + referInfo.projek + '/' + referInfo.bt_id + '/' + referInfo.ordinal).then(data => data.json()).then(result => {
                console.log(result.id);
                setInskrywingId(result.id);
            });
        }
        else {
            fetch('api/User/nuweinskrywing/' + referInfo.projek + '/' + referInfo.ordernumber).then(data => data.json()).then(result => {
                console.log(result.id);
                setInskrywingId(result.id);
            });
        }

    }
    const finishRegistrationKuns = async () => {
        //when finished uploading is clicked, create db entry for newUploadedFiles and set oplaaistatus as 'Besig om op te laai'
        //add if statement for groups (add ordinal in fetch query)
        //start upload ui
        setKunsOpgelaai(false);
        setTeksOpgelaai(false);
        setIsUploading(true);
        if (window.location.pathname.includes("groep")) {
            fetch('api/User/nuweinskrywing/' + referInfo.projek + '/' + referInfo.bt_id + '/' + referInfo.ordinal).then(data => data.json()).then(result => {
                console.log(result.id);
                setInskrywingId(result.id);
            });
        }
        else {
            fetch('api/User/nuweinskrywing/' + referInfo.projek + '/' + referInfo.ordernumber).then(data => data.json()).then(result => {
                console.log(result.id);
                setInskrywingId(result.id);
            });
        }


    }
    const finishRegistrationSkryf = async () => {
        //when finished uploading is clicked, create db entry for newUploadedFiles and set oplaaistatus as 'Besig om op te laai'
        //add if statement for groups (add ordinal in fetch query)
        //start upload ui
        setKunsOpgelaai(false);
        setTeksOpgelaai(false);
        setIsUploading(true);
        if (window.location.pathname.includes("groep")) {
            fetch('api/User/nuweinskrywing/' + referInfo.projek + '/' + referInfo.bt_id + '/' + referInfo.ordinal).then(data => data.json()).then(result => {
                console.log(result.id);
                setInskrywingId(result.id);
            });
        }
        else {
            fetch('api/User/nuweinskrywing/' + referInfo.projek + '/' + referInfo.ordernumber).then(data => data.json()).then(result => {
                console.log(result.id);
                setInskrywingId(result.id);
            });
        }


    }

    //Laai die digitale beeld van die deelnemer se kunswerk hier:
    //Laai die lied, waarop die deelnemer se kunswerk gebaseer is, se woorde in teksvorm hier:
    useEffect(() => {
    }, [kunsOpgelaai, vidOpgelaai])
    switch (referInfo.projek) {
        case "DigiKuns":
            return (<Grid>
                             <Grid container spacing={3} justify="center">
                    <Grid item xs={12}></Grid>
                    <Grid container justify="center" item xs={12}>

                        <Button
                            variant="contained"
                            component="label"
                            color="primary"
                            size="large"
                        >

                            Kies kunswerk
                    <input
                                id="kuns-input"
                                type="file"
                                accept=".jpg, .jpeg, .png, .pdf"
                                style={{ display: "none" }}
                                onChange={(e) => kunsInputChanged(e)}

                            />
                        </Button>
                    </Grid>
                    {/* No longer submitting text for DigiKuns */}
                    {/* 
                    <Grid container justify="center" item xs={12}>
                        <Button
                            variant="contained"
                            component="label"
                            color="primary"
                            size="large"
                        >

                            Kies lied se woorde
                            <input
                                id="teks-input"
                                type="file"
                                accept=".docx,.doc,.txt,.pdf,.jpeg, .jpg"
                                style={{ display: "none" }}
                                onChange={(e) => teksInputChanged(e)}

                            />
                        </Button>
                    </Grid>
                    */}
                    <Grid container justify="center" item xs={12}>
                        {kunsOpgelaai ? <p> {kuns} </p> : <p> </p>}
                        <br />
                        {/* No longer submitting text for DigiKuns */}
                        {/* {teksOpgelaai ? <p> {teks} </p> : <p> </p>} */}

                        <Grid container spacing={3} justify="center">

                            <Button variant="contained" size="large" color="primary" disabled={!(kunsOpgelaai && teksOpgelaai)} onClick={finishRegistrationKuns}>Laai op</Button>

                        </Grid>
                        <br />
                        {isUploading ?
                            <Grid>
                                <Grid>
                                    <Typography variant="body1" gutterBottom>{status}
                                    </Typography>
                                    <Typography variant="body1" gutterBottom>{progressVal.toFixed(2) + '%'}
                                    </Typography>
                                </Grid>
                                <Grid>
                                    <LinearProgress value={progressVal} variant="determinate" />
                                </Grid>

                            </Grid> : <br />}
                    </Grid>
                </Grid>
            </Grid>)
        case "DigiPraat":
            return(<div>
                    <Grid container justify="center">
                        <div className={classes.root}>

                            <Button
                                variant="contained"
                                component="label"
                                color="primary"
                                size="large"
                            >
                                Kies videomateriaal
                    <input
                                    id="vid-input"
                                    type="file"
                                    accept="video/*"
                                    style={{ display: "none" }}
                                    onChange={(e) => vidInputChanged(e)}

                                />
                            </Button>
                        </div>
                    </Grid>
                    <Grid container justify="center">
                        <Grid item>
                            {vidOpgelaai ? <p> {vid} </p> : <p> </p>}
                        </Grid>
                    </Grid>
                    <Grid container spacing={3} justify="center">
                          <Button variant="contained" size="large" color="primary" disabled={!vidOpgelaai} onClick={finishRegistration}>Laai op</Button>
                    </Grid>
                    <br />

                    {isUploading ?
                        <Grid>
                            <Grid>
                                <Typography variant="body1" gutterBottom>{status}
                                </Typography>
                                <Typography variant="body1" gutterBottom>{progressVal.toFixed(2) + '%'}
                                </Typography>
                            </Grid>
                            <Grid>
                                <LinearProgress value={progressVal} variant="determinate" />
                            </Grid>

                        </Grid> : <br />}
                </div>)
        case "Redenaars":
            {/* <div>
                <Grid container justify="center">
                    <div className={classes.root}>

                        <Button
                            variant="contained"
                            component="label"
                            color="primary"
                            size="large"
                        >
                            Kies videomateriaal
                    <input
                                id="vid-input"
                                type="file"
                                accept="video/*"
                                style={{ display: "none" }}
                                onChange={(e) => vidInputChanged(e)}

                            />
                        </Button>
                    </div>
                </Grid>
                <Grid container justify="center">
                    <Grid item>
                        {vidOpgelaai ? <p> {vid} </p> : <p> </p>}
                    </Grid>
                </Grid>
                <Grid container spacing={3} justify="center">
                    <Button variant="contained" size="large" color="primary" disabled={!vidOpgelaai} onClick={finishRegistration}>Laai op</Button>
                </Grid>
                <br />

                {isUploading ?
                    <Grid>
                        <Grid>
                            <Typography variant="body1" gutterBottom>{status}
                            </Typography>
                            <Typography variant="body1" gutterBottom>{progressVal.toFixed(2) + '%'}
                            </Typography>
                        </Grid>
                        <Grid>
                            <LinearProgress value={progressVal} variant="determinate" />
                        </Grid>

                    </Grid> : <br />}
            </div>*/ }
            return (<InterimUpload />)
        case "DigiSkryf":
            return (<div>
                <Grid container justify="center" item xs={12}>
                    <Grid container justify="center" item xs={12}>
                    <Button
                        variant="contained"
                        component="label"
                        color="primary"
                        size="large"
                    >

                        Kies skryfstuk
                            <input
                            id="skryfteks-input"
                            type="file"
                            accept=".docx,.doc,.txt,.pdf,.jpeg, .jpg"
                            style={{ display: "none" }}
                            onChange={(e) => skryfTeksInputChanged(e)}

                        />
                        </Button>
                    </Grid>
                    <Grid container justify="center" item xs={12}>
                        {skryfTeksOpgelaai ? <p> {skryfTeks} </p> : <p> </p>}
                        <br />

                        <Grid container justify="center">

                            <Button variant="contained" size="large" color="primary" disabled={!skryfTeksOpgelaai} onClick={finishRegistrationSkryf}>Laai op</Button>

                        </Grid>
                        <br />
                        {isUploading ?
                            <Grid>
                                <Grid>
                                    <Typography variant="body1" gutterBottom>{status}
                                    </Typography>
                                    <Typography variant="body1" gutterBottom>{progressVal.toFixed(2) + '%'}
                                    </Typography>
                                </Grid>
                                <Grid>
                                    <LinearProgress value={progressVal} variant="determinate" />
                                </Grid>

                            </Grid> : <br />}
                    </Grid>

                </Grid>
            </div>)
        case "DigiSpanpraat":
            return (<div>
                <Grid container justify="center">
                    <div className={classes.root}>

                        <Button
                            variant="contained"
                            component="label"
                            color="primary"
                            size="large"
                        >
                            Kies videomateriaal
                    <input
                                id="vid-input"
                                type="file"
                                accept="video/*"
                                style={{ display: "none" }}
                                onChange={(e) => vidInputChanged(e)}

                            />
                        </Button>
                    </div>
                </Grid>
                <Grid container justify="center">
                    <Grid item>
                        {vidOpgelaai ? <p> {vid} </p> : <p> </p>}
                    </Grid>
                </Grid>
                <Grid container spacing={3} justify="center">
                    <Button variant="contained" size="large" color="primary" disabled={!vidOpgelaai} onClick={finishRegistration}>Laai op</Button>
                </Grid>
                <br />

                {isUploading ?
                    <Grid>
                        <Grid>
                            <Typography variant="body1" gutterBottom>{status}
                            </Typography>
                            <Typography variant="body1" gutterBottom>{progressVal.toFixed(2) + '%'}
                            </Typography>
                        </Grid>
                        <Grid>
                            <LinearProgress value={progressVal} variant="determinate" />
                        </Grid>

                    </Grid> : <br />}
            </div>)

        default:
            return (<InterimUpload />)
    }


}

export default UploadBlobAzure;


// WEBPACK FOOTER //
// ./src/components/UploadBlobAzure.js